import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const addAssetFinalAdapter = createEntityAdapter({})
const initialState = addAssetFinalAdapter.getInitialState()
export const addAssetFinalApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAssetsFinal: builder.query({
            query: () => ({
                url: '/addasset/final',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedAddAssetFinal = responseData.map(addAssetFinal => {
                    // console.log(addAssetFinal)
                    addAssetFinal.id = addAssetFinal._id
                    // console.log(addAssetFinal)
                    return addAssetFinal
                });
                return addAssetFinalAdapter.setAll(initialState, loadedAddAssetFinal)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'AddAssetFinal', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'AddAssetFinal', id }))
                    ]
                } else return [{ type: 'AddAssetFinal', id: 'LIST' }]
            }
        }),
        getAssetsFinalFiltered: builder.query({
            query: ({ page , limit , filters = {} }) => {
              console.time("getAssetsFinalFiltered - API Request"); // Start time
              return {
                url: "/addasset/finalfiltered",
                params: { ...filters, page, limit },
                validateStatus: (response) => response.status === 200,
              };
            },
            transformResponse: (responseData) => {          
              const transformedData = {
                assets: responseData.assets?.map((asset) => ({
                  ...asset,
                  id: asset._id, // Ensure `id` is mapped correctly
                })) || [],
                totalFilteredAssets: responseData.totalFilteredAssets || 0,
                totalPages: responseData.totalPages || 1,
              };
          
              return transformedData;
            },
            providesTags: (result) =>
              result?.assets
                ? [
                    { type: "AddAssetFinal", id: "LIST" },
                    ...result.assets.map((asset) => ({
                      type: "AddAssetFinal",
                      id: asset.id,
                    })),
                  ]
                : [{ type: "AddAssetFinal", id: "LIST" }],
          }),
          
                  
        addNewAssetFinal: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/final',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'AddAssetFinal', id: "LIST" }
            ]
        }),
        updateAddAssetFinal: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/final',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateAssetintransit: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/intransit',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateAssetHandover: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/handover',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateOffAssetHandover: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/offassetsho',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateOffToOffAssetTran: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/offtoofftrans',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateStrToStrAssetTran: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/strtostrtrans',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateOldIssueDate: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/oldissuedate',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),
        updateMultipleDocs: builder.mutation({
            query: initialUserData => ({
                url: '/addasset/updatemultiple',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'AddAssetFinal', id: arg.id }
            ]
        }),

    }),
})


export const {
    useGetAssetsFinalQuery,
    useAddNewAssetFinalMutation,
    useUpdateAddAssetFinalMutation,
    useUpdateAssetintransitMutation,
    useUpdateAssetHandoverMutation,
    useUpdateOffAssetHandoverMutation,
    useUpdateOffToOffAssetTranMutation,
    useUpdateStrToStrAssetTranMutation,
    useUpdateOldIssueDateMutation,
    useGetAssetsFinalFilteredQuery,
    useLazyGetAssetsFinalFilteredQuery,
    useUpdateMultipleDocsMutation
} = addAssetFinalApiSlice


// returns the query result object
export const selectAddAssetFinalsResult = addAssetFinalApiSlice.endpoints.getAssetsFinal.select()

// creates memoized selector
const selectAddAssetFinalsData = createSelector(
    selectAddAssetFinalsResult,
    addAssetFinalsResult => addAssetFinalsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllAddAssetFinals,
    selectById: selectAddAssetFinalById,
    selectIds: selectAddAssetFinalIds
    // Pass in a selector that returns the users slice of state
} = addAssetFinalAdapter.getSelectors(state => selectAddAssetFinalsData(state) ?? initialState)